// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"c9cb750e","270":"8d5d522b","453":"7a6b1830","489":"a18c3b42","555":"e0781bee","963":"727d776d"}[chunkId] + ".chunk.js";
};